export default __webpack_public_path__ + "static/media/discussion.d07f0c6e.svg";